module.exports = __webpack_public_path__ + "img/LCat-01.5ec12048.png";